module.exports = __webpack_public_path__ + "img/facebook.6dbc1066.svg";